import styled, { css } from 'styled-components';

export const LABEL_TOP_NAME = 'top';
export const LABEL_LEFT_NAME = 'left';

export const StyledLabels = styled.div`
    display: grid;

    ${({ position, count }) => position === LABEL_TOP_NAME && css`
        grid-template-columns: repeat(${count}, 1fr);
        grid-area: top;
        align-items: end;
    `}

    ${({ position, count }) => position === LABEL_LEFT_NAME && css`
        grid-template-rows: repeat(${count}, 1fr);
        grid-area: left;
        margin-inline-end: 8px;
    `}
`;

export const Label = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 900;
    color: #00afff;

    ${({ $position }) => $position === LABEL_TOP_NAME && css`
        padding-bottom: 4px;
    `}

    ${({ $position }) => $position === LABEL_LEFT_NAME && css`
        justify-content: flex-end;
        padding-right: 4px;
    `}

    @media (max-width: ${({ theme }) => theme.breakpoints.laptopMax}px) {
        font-size: max(12px, 1.5vw);
    }
`;
